/**
  * @file
  * Attach behaviors for the Main menu.
  */

!((document, Drupal, $) => {
  'use strict';

  /**
   * Setup and attach the Main Menu Toggle.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.mainMenu = {

    attach: function (context) {
      const $menuToggle = $('.main-menu__toggle', context);
      const $menuFullPage = $('.main-menu__full-page-container', context);
      const $menuList = $('.main-menu__links-list', context);
      const $mainMenu = $('.main-menu', context);
      const $header = $('.header', context);
      const $mobileMenu = $('.header__mobile', context);
      const $menuHamburger = $('.main-menu__control', context);
      const $jsToggle = 'js-menu-open';

      $menuToggle.on('click', function () {
        $(this).toggleClass($jsToggle);
        $menuFullPage.toggleClass($jsToggle);
        $menuHamburger.toggleClass($jsToggle);
        $mainMenu.toggleClass($jsToggle);
        $header.toggleClass($jsToggle);
        $mobileMenu.toggleClass($jsToggle);
        $('body').toggleClass('main-menu__no-scroll');

        if ($(this).hasClass($jsToggle)) {
          $(this).attr('aria-expanded', 'true');
          $menuList.attr('aria-hidden', 'false');
        }

        else {
          $(this).attr('aria-expanded', 'false');
          $menuList.attr('aria-hidden', 'true');
        }
      });
    }
  };
})(document, Drupal, jQuery);
